import { createContext, useReducer, useEffect } from 'react';

export const AuthSlice = createContext();

export const authReducer = (state, action) => {
    switch (action.type) {
        // Cases for agency
        case 'AGENCY_LOGIN':
            return {
                ...state,
                agency: action.payload
            };
        case 'AGENCY_LOGOUT':
            return {
                ...state,
                agency: null
            };
        default:
            return state;
    }
};

export const AuthContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(authReducer, {
        agency: null,
    });

    useEffect(() => {
        // Helper function to get user data from storage
        const getUserDataFromStorage = (key) => {
            const dataFromLocalStorage = localStorage.getItem(key);
            const dataFromSessionStorage = sessionStorage.getItem(key);

            return dataFromLocalStorage
                ? JSON.parse(dataFromLocalStorage)
                : dataFromSessionStorage
                    ? JSON.parse(dataFromSessionStorage)
                    : null;
        };

        // Check for agency in both localStorage and sessionStorage
        const agency = getUserDataFromStorage('agency');
        if (agency) {
            dispatch({ type: 'AGENCY_LOGIN', payload: agency });
        }
    }, []);

    return (
        <AuthSlice.Provider value={{ ...state, dispatch }}>
            {children}
        </AuthSlice.Provider>
    );
};
